/**
 * Permission types to protect HTTP endpoints.
 *
 * Important: Always create dedicated permissions for your endpoints rather than using generic ones.
 * Each endpoint should have its own specific permission that clearly describes what it allows.
 */
export enum PermissionType {
  SHOW_OPERATIONS_PRODUCT = 'SHOW_OPERATIONS_PRODUCT',
  SHOW_EAM_PRODUCT = 'SHOW_EAM_PRODUCT',
  SHOW_ELIGIBILITY_PRODUCT = 'SHOW_ELIGIBILITY_PRODUCT',
  SHOW_RESOLVE_PRODUCT = 'SHOW_RESOLVE_PRODUCT',
  SHOW_ANALYZE_PRODUCT = 'SHOW_ANALYZE_PRODUCT',
  SHOW_ANALYTICS_PRODUCT = 'SHOW_ANALYTICS_PRODUCT',
  SHOW_AI_PRODUCT = 'SHOW_AI_PRODUCT',
  SHOW_REALIZE_PRODUCT = 'SHOW_REALIZE_PRODUCT',
  SHOW_ADMIN_PRODUCT = 'SHOW_ADMIN_PRODUCT',

  GET_OWN_REVIEW = 'GET_OWN_REVIEW',
  GET_ANY_REVIEW = 'GET_ANY_REVIEW',
  POST_OWN_REVIEW = 'POST_OWN_REVIEW',
  POST_ANY_REVIEW = 'POST_ANY_REVIEW',

  GET_ANY_ANNOUNCEMENT = 'GET_ANY_ANNOUNCEMENT',
  LIST_ACTIVE_ANNOUNCEMENT = 'LIST_ACTIVE_ANNOUNCEMENT',

  WRITE_ANY_ANNOUNCEMENT = 'WRITE_ANY_ANNOUNCEMENT',

  GET_ANY_PROMO = 'GET_ANY_PROMO',
  LIST_ANY_PROMO = 'LIST_ANY_PROMO',
  WRITE_ANY_PROMO = 'WRITE_ANY_PROMO',

  GET_SENSITIVE_INFORMATION = 'GET_SENSITIVE_INFORMATION',

  GET_OWN_AI_CHAT_CONVERSATION = 'GET_OWN_AI_CHAT_CONVERSATION',
  WRITE_OWN_AI_CHAT_CONVERSATION = 'WRITE_OWN_AI_CHAT_CONVERSATION',
  GET_OWN_AI_CHAT_MESSAGE = 'GET_OWN_AI_CHAT_MESSAGE',
  WRITE_OWN_AI_CHAT_MESSAGE = 'WRITE_OWN_AI_CHAT_MESSAGE',

  GET_ANY_KNOWLEDGE_ENTRY = 'GET_ANY_KNOWLEDGE_ENTRY',
  WRITE_ANY_KNOWLEDGE_ENTRY = 'WRITE_ANY_KNOWLEDGE_ENTRY',

  GET_ANY_PHONE_NUMBER = 'GET_ANY_PHONE_NUMBER',
  UPDATE_ANY_PHONE_NUMBER = 'UPDATE_ANY_PHONE_NUMBER',
  PURCHASE_ANY_PHONE_NUMBER = 'PURCHASE_ANY_PHONE_NUMBER',
  DELETE_ANY_PHONE_NUMBER = 'DELETE_ANY_PHONE_NUMBER',

  GET_ANY_PROMO_ALLOCATION = 'GET_ANY_PROMO_ALLOCATION',
  POST_ANY_PROMO_ALLOCATION = 'POST_ANY_PROMO_ALLOCATION',
  GET_OWN_PROMO_ALLOCATION = 'GET_OWN_PROMO_ALLOCATION',
  POST_OWN_PROMO_ALLOCATION = 'POST_OWN_PROMO_ALLOCATION',

  GET_ANY_FARE_PASS = 'GET_ANY_FARE_PASS',
  WRITE_ANY_FARE_PASS = 'WRITE_ANY_FARE_PASS',

  GET_OWN_FARE_PASS_ALLOCATION = 'GET_OWN_FARE_PASS_ALLOCATION',
  GET_ANY_FARE_PASS_ALLOCATION = 'GET_ANY_FARE_PASS_ALLOCATION',
  EXPORT_ANY_FARE_PASS_ALLOCATION = 'EXPORT_ANY_FARE_PASS_ALLOCATION',
  POST_OWN_FARE_PASS_ALLOCATION = 'POST_OWN_FARE_PASS_ALLOCATION',
  POST_ANY_FARE_PASS_ALLOCATION = 'POST_ANY_FARE_PASS_ALLOCATION',
  PATCH_ANY_FARE_PASS_ALLOCATION = 'PATCH_ANY_FARE_PASS_ALLOCATION',
  IMPORT_ANY_FARE_PASS_ALLOCATION = 'IMPORT_ANY_FARE_PASS_ALLOCATION',

  LIST_ANY_FARE_REDEMPTION = 'LIST_ANY_FARE_REDEMPTION',

  GET_ANY_SERVICE = 'GET_ANY_SERVICE',
  LIST_ANY_SERVICE = 'LIST_ANY_SERVICE',
  WRITE_ANY_SERVICE = 'WRITE_ANY_SERVICE',
  DELETE_ANY_SERVICE = 'DELETE_ANY_SERVICE',

  GET_ANY_ROUTE = 'GET_ANY_ROUTE',
  LIST_ANY_ROUTE = 'LIST_ANY_ROUTE',
  WRITE_ANY_ROUTE = 'WRITE_ANY_ROUTE',

  POST_ANY_ROUTE_ASSIGNMENT = 'POST_ANY_ROUTE_ASSIGNMENT',
  DELETE_ANY_ROUTE_ASSIGNMENT = 'DELETE_ANY_ROUTE_ASSIGNMENT',
  LIST_ANY_ROUTE_ASSIGNMENT = 'LIST_ANY_ROUTE_ASSIGNMENT',
  LIST_ANY_ROUTE_ASSIGNMENT_STATE = 'LIST_ANY_ROUTE_ASSIGNMENT_STATE',

  GET_ANY_FLEET = 'GET_ANY_FLEET',
  LIST_ANY_FLEET = 'LIST_ANY_FLEET',
  PATCH_ANY_FLEET = 'PATCH_ANY_FLEET',
  POST_ANY_FLEET = 'POST_ANY_FLEET',

  GET_ANY_FLEET_PROVIDER = 'GET_ANY_FLEET_PROVIDER',
  LIST_ANY_FLEET_ACCESS = 'LIST_ANY_FLEET_ACCESS',
  POST_ANY_FLEET_ACCESS = 'POST_ANY_FLEET_ACCESS',
  DELETE_ANY_FLEET_ACCESS = 'DELETE_ANY_FLEET_ACCESS',

  POST_ANY_SERVICE_FLEET = 'POST_ANY_SERVICE_FLEET',
  DELETE_ANY_SERVICE_FLEET = 'DELETE_ANY_SERVICE_FLEET',
  LIST_ANY_SERVICE_FLEET = 'LIST_ANY_SERVICE_FLEET',
  PATCH_ANY_SERVICE_FLEET = 'PATCH_ANY_SERVICE_FLEET',

  GET_OWN_REQUEST = 'GET_OWN_REQUEST',
  GET_ANY_REQUEST = 'GET_ANY_REQUEST',
  LIST_ANY_REQUEST = 'LIST_ANY_REQUEST',
  POST_OWN_REQUEST = 'POST_OWN_REQUEST',
  POST_ANY_REQUEST = 'POST_ANY_REQUEST',
  PATCH_OWN_REQUEST = 'PATCH_OWN_REQUEST',
  PATCH_ANY_REQUEST = 'PATCH_ANY_REQUEST',
  IMPORT_ANY_REQUEST = 'IMPORT_ANY_REQUEST',
  POST_OWN_REQUEST_FARE_ESTIMATE = 'POST_OWN_REQUEST_FARE_ESTIMATE',
  POST_ANY_REQUEST_FARE_ESTIMATE = 'POST_ANY_REQUEST_FARE_ESTIMATE',
  POST_OWN_REQUEST_CANCELLATION = 'POST_OWN_REQUEST_CANCELLATION',
  POST_OWN_REQUEST_CANCELLATION_AS_DRIVER = 'POST_OWN_REQUEST_CANCELLATION_AS_DRIVER',
  POST_ANY_REQUEST_CANCELLATION = 'POST_ANY_REQUEST_CANCELLATION',
  POST_ANY_REQUEST_NO_SHOW_REVERSAL = 'POST_ANY_REQUEST_NO_SHOW_REVERSAL',
  POST_ANY_REQUEST_EDIT_DROPOFF = 'POST_ANY_REQUEST_EDIT_DROPOFF',
  POST_ANY_REQUEST_UNMATCH = 'POST_ANY_REQUEST_UNMATCH',
  POST_ANY_REQUEST_REVERSE_PICKUP = 'POST_ANY_REQUEST_REVERSE_PICKUP',
  POST_ANY_REQUEST_REVERSE_CANCELLATION = 'POST_ANY_REQUEST_REVERSE_CANCELLATION',
  POST_ANY_REQUEST_REVERSE_DROPOFF = 'POST_ANY_REQUEST_REVERSE_DROPOFF',
  POST_ANY_REQUEST_FORCE_MATCH = 'POST_ANY_REQUEST_FORCE_MATCH',
  GET_OWN_LAST_REQUEST_VL = 'GET_OWN_REQUEST_VL',
  GET_ANY_LAST_REQUEST_VL = 'GET_ANY_REQUEST_VL',
  GET_OWN_REQUEST_VEHICLE = 'GET_OWN_REQUEST_VEHICLE',
  GET_ANY_REQUEST_VEHICLE = 'GET_ANY_REQUEST_VEHICLE',
  POST_ANY_REQUEST_REMATCH = 'POST_ANY_REQUEST_REMATCH',
  GET_OWN_REQUEST_SLOTS = 'GET_OWN_REQUEST_SLOTS',
  GET_ANY_REQUEST_SLOTS = 'GET_ANY_REQUEST_SLOTS',
  GET_ANY_REQUEST_INSIGHTS = 'GET_ANY_REQUEST_INSIGHTS',
  GET_OWN_REQUEST_INSIGHTS = 'GET_OWN_REQUEST_INSIGHTS',
  PATCH_ANY_REQUEST_METADATA = 'PATCH_ANY_REQUEST_METADATA',
  GET_ANY_REQUEST_PAYMENT_OPTIONS = 'GET_ANY_REQUEST_PAYMENT_OPTIONS',
  GET_OWN_REQUEST_PAYMENT_OPTIONS = 'GET_OWN_REQUEST_PAYMENT_OPTIONS',
  GET_ANY_REQUEST_PREDICTIONS = 'GET_ANY_REQUEST_PREDICTIONS',
  GET_OWN_REQUEST_PREDICTIONS = 'GET_OWN_REQUEST_PREDICTIONS',
  LOCK_REQUEST_TO_DUTY = 'LOCK_REQUEST_TO_DUTY',

  CAN_CREATE_OWN_UNMATCHED_REQUEST = 'CAN_CREATE_OWN_UNMATCHED_REQUEST',
  CAN_CREATE_ANY_UNMATCHED_REQUEST = 'CAN_CREATE_ANY_UNMATCHED_REQUEST',
  WRITE_RESTRICTED_SERVICE_REQUEST = 'WRITE_RESTRICTED_SERVICE_REQUEST',

  GET_OWN_TIP = 'GET_OWN_TIP',
  GET_ANY_TIP = 'GET_ANY_TIP',
  POST_OWN_TIP = 'POST_OWN_TIP',
  POST_ANY_TIP = 'POST_ANY_TIP',

  LIST_ANY_TIP_POLICY = 'LIST_ANY_TIP_POLICY',
  GET_ANY_TIP_POLICY = 'GET_ANY_TIP_POLICY',
  WRITE_ANY_TIP_POLICY = 'WRITE_ANY_TIP_POLICY',
  DELETE_ANY_TIP_POLICY = 'DELETE_ANY_TIP_POLICY',

  GET_OWN_VEHICLE = 'GET_OWN_VEHICLE',
  GET_ANY_VEHICLE = 'GET_ANY_VEHICLE',
  LIST_ANY_VEHICLE = 'LIST_ANY_VEHICLE',
  WRITE_OWN_VEHICLE = 'WRITE_OWN_VEHICLE',
  PATCH_ANY_VEHICLE = 'PATCH_ANY_VEHICLE',
  POST_ANY_VEHICLE = 'POST_ANY_VEHICLE',
  IMPORT_ANY_VEHICLE = 'IMPORT_ANY_VEHICLE',

  GET_ANY_PROVIDER = 'GET_ANY_PROVIDER',
  WRITE_ANY_PROVIDER = 'WRITE_ANY_PROVIDER',

  PREVIEW_ANY_SIMULATION = 'PREVIEW_ANY_SIMULATION',
  POST_ANY_SIMULATION = 'POST_ANY_SIMULATION',

  GET_ANY_SIMULATION_RESULT = 'GET_ANY_SIMULATION_RESULT',
  WRITE_ANY_SIMULATION_RESULT = 'WRITE_ANY_SIMULATION_RESULT',
  DELETE_ANY_SIMULATION_RESULT = 'DELETE_ANY_SIMULATION_RESULT',

  GET_OWN_SLOT = 'GET_OWN_SLOT',
  GET_ANY_SLOT = 'GET_ANY_SLOT',
  LIST_ANY_SLOT = 'LIST_ANY_SLOT',
  COMPLETE_ANY_SLOT = 'COMPLETE_ANY_SLOT',

  GET_ANY_STOP = 'GET_ANY_STOP',
  LIST_ANY_STOP = 'LIST_ANY_STOP',
  POST_ANY_STOP = 'POST_ANY_STOP',
  PATCH_ANY_STOP = 'PATCH_ANY_STOP',
  DELETE_ANY_STOP = 'DELETE_ANY_STOP',
  DELETE_ANY_MULTIPLE_STOPS = 'DELETE_ANY_MULTIPLE_STOPS',
  IMPORT_ANY_STOP = 'IMPORT_ANY_STOP',

  GET_ANY_ZONE = 'GET_ANY_ZONE',
  LIST_ANY_ZONE = 'LIST_ANY_ZONE',
  POST_ANY_ZONE = 'POST_ANY_ZONE',
  PATCH_ANY_ZONE = 'PATCH_ANY_ZONE',
  DELETE_ANY_ZONE = 'DELETE_ANY_ZONE',
  GET_ANY_USER_BAN = 'GET_ANY_USER_BAN',
  WRITE_ANY_USER_BAN = 'WRITE_ANY_USER_BAN',

  // // NEW USER PERMISSIONS

  GET_OWN_USER = 'GET_OWN_USER',
  PATCH_OWN_USER = 'PATCH_OWN_USER',
  DELETE_OWN_USER = 'DELETE_OWN_USER',

  GET_OWN_RIDER = 'GET_OWN_RIDER',
  // TODO - look if we can change this
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  PATCH_OWN_RIDER = 'GET_OWN_RIDER',
  GET_OWN_DRIVER = 'GET_OWN_DRIVER',
  PATCH_OWN_DRIVER = 'PATCH_OWN_DRIVER',
  GET_OWN_ADMIN = 'GET_OWN_ADMIN',
  PATCH_OWN_ADMIN = 'PATCH_OWN_ADMIN',

  GET_ANY_RIDER = 'GET_ANY_RIDER',
  LIST_ANY_RIDER = 'LIST_ANY_RIDER',
  PATCH_ANY_RIDER = 'PATCH_ANY_RIDER',
  POST_ANY_RIDER = 'POST_ANY_RIDER',
  ARCHIVE_ANY_RIDER = 'ARCHIVE_ANY_RIDER',
  DELETE_ANY_RIDER = 'DELETE_ANY_RIDER',
  DELETE_ANY_MULTIPLE_RIDERS = 'DELETE_ANY_MULTIPLE_RIDERS',
  IMPORT_ANY_RIDER = 'IMPORT_ANY_RIDER',

  GET_ANY_DRIVER = 'GET_ANY_DRIVER',
  LIST_ANY_DRIVER = 'LIST_ANY_DRIVER',
  PATCH_ANY_DRIVER = 'PATCH_ANY_DRIVER',
  POST_ANY_DRIVER = 'POST_ANY_DRIVER',
  DELETE_ANY_DRIVER = 'DELETE_ANY_DRIVER',
  DELETE_ANY_MULTIPLE_DRIVERS = 'DELETE_ANY_MULTIPLE_DRIVERS',
  IMPORT_ANY_DRIVER = 'IMPORT_ANY_DRIVER',

  GET_ANY_ADMIN = 'GET_ANY_ADMIN',
  PATCH_ANY_ADMIN = 'PATCH_ANY_ADMIN',
  POST_ANY_ADMIN = 'POST_ANY_ADMIN',
  DELETE_ANY_ADMIN = 'DELETE_ANY_ADMIN',
  IMPORT_ANY_ADMIN = 'IMPORT_ANY_ADMIN',

  LIST_METRICS = 'LIST_METRICS',
  POST_DOPS_UPDATE_OFFER = 'POST_DOPS_UPDATE_OFFER',
  GET_ANY_DUTY_REQUEST_OFFER = 'GET_ANY_DUTY_REQUEST_OFFER',

  POST_DOPS_COMPLETE_SLOT = 'POST_DOPS_COMPLETE_SLOT',
  POST_DOPS_COMPLETE_DUTY = 'POST_DOPS_COMPLETE_DUTY',
  POST_DOPS_START_DRIVER_BREAK = 'POST_DOPS_START_DRIVER_BREAK',
  POST_DOPS_ARRIVE_AT_SLOTS = 'POST_DOPS_ARRIVE_AT_SLOTS',
  GET_DOPS_FLAGDOWN_ESTIMATE = 'GET_DOPS_FLAGDOWN_ESTIMATE',
  POST_DOPS_FLAGDOWN_REQUEST = 'POST_DOPS_FLAGDOWN_REQUEST',
  GET_DOPS_FLAGDOWN_REQUEST = 'GET_DOPS_FLAGDOWN_REQUEST',
  GET_DOPS_RIDER = 'GET_DOPS_RIDER',

  GET_DOPS_EARNINGS_SUMMARY = 'GET_DOPS_EARNINGS_SUMMARY',

  POST_DOPS_VOIP_ACCESS_TOKEN = 'POST_DOPS_VOIP_ACCESS_TOKEN',

  POST_DOPS_DRIVER_RIDER_CALL_EVENT = 'POST_DOPS_DRIVER_RIDER_CALL_EVENT',

  POST_DOPS_COMMS_ACCESS_TOKEN = 'POST_DOPS_COMMS_ACCESS_TOKEN',
  POST_DISPATCHER_COMMS_ACCESS_TOKEN = 'POST_DISPATCHER_COMMS_ACCESS_TOKEN',

  LIST_DOPS_PAST_REQUESTS = 'LIST_DOPS_PAST_REQUESTS',

  POST_DOPS_SLOT_NAVIGATION_STARTED_EVENT = 'POST_DOPS_SLOT_NAVIGATION_STARTED_EVENT',

  POST_UPLOAD_PHOTO = 'POST_UPLOAD_PHOTO',
  POST_ANY_FILE = 'POST_ANY_FILE',
  GET_ANY_FILE = 'GET_ANY_FILE',
  POST_ANY_FILE_SCAN = 'POST_ANY_FILE_SCAN',

  GET_ESTIMATE_SERVICES = 'GET_ESTIMATE_SERVICES',
  GET_ESTIMATE_SERVICES_FROM = 'GET_ESTIMATE_SERVICES_FROM',
  GET_ESTIMATE_SERVICES_TO = 'GET_ESTIMATE_SERVICES_TO',
  GET_SERVICE_AVAILABILITY = 'GET_SERVICE_AVAILABILITY',
  GET_OWN_ESTIMATE_REQUEST = 'GET_OWN_ESTIMATE_REQUEST',
  GET_ANY_ESTIMATE_REQUEST = 'GET_ANY_ESTIMATE_REQUEST',
  GET_ANY_ESTIMATE_REQUEST_WITH_OVERRIDES = 'GET_ANY_ESTIMATE_REQUEST_WITH_OVERRIDES',

  GET_JOURNEY_ESTIMATES = 'GET_JOURNEY_ESTIMATES',
  GET_JOURNEY_OPTIONS = 'GET_JOURNEY_OPTIONS',

  GET_OWN_JOURNEY = 'GET_OWN_JOURNEY',
  WRITE_OWN_JOURNEY = 'WRITE_OWN_JOURNEY',

  GET_ANY_JOURNEY = 'GET_ANY_JOURNEY',
  WRITE_ANY_JOURNEY = 'WRITE_ANY_JOURNEY',

  GET_ANY_DUTY_DELAY = 'GET_ANY_DUTY_DELAY',

  POST_OWN_STRIPE_TOKEN = 'POST_OWN_STRIPE_TOKEN',
  POST_OWN_STRIPE_SESSION = 'POST_OWN_STRIPE_SESSION',
  POST_ANY_STRIPE_SESSION = 'POST_ANY_STRIPE_SESSION',
  POST_OWN_STRIPE_SETUP_INTENT = 'POST_OWN_STRIPE_SETUP_INTENT',
  POST_ANY_STRIPE_SETUP_INTENT = 'POST_ANY_STRIPE_SETUP_INTENT',
  POST_OWN_NIMOCA_ID = 'POST_OWN_NIMOCA_ID',
  POST_ANY_GOPASS_PAYMENT_METHOD = 'POST_ANY_GOPASS_PAYMENT_METHOD',

  POST_ANY_WALLET = 'POST_ANY_WALLET',
  POST_OWN_WALLET = 'POST_OWN_WALLET',
  IMPORT_ANY_WALLET = 'IMPORT_ANY_WALLET',

  LIST_OWN_WALLET_TRANSACTION = 'LIST_OWN_WALLET_TRANSACTION',
  LIST_ANY_WALLET_TRANSACTION = 'LIST_ANY_WALLET_TRANSACTION',

  WRITE_ANY_WALLET_AUTO_TOP_UP = 'WRITE_ANY_WALLET_AUTO_TOP_UP',
  WRITE_OWN_WALLET_AUTO_TOP_UP = 'WRITE_OWN_WALLET_AUTO_TOP_UP',
  DELETE_ANY_WALLET_AUTO_TOP_UP = 'DELETE_ANY_WALLET_AUTO_TOP_UP',
  DELETE_OWN_WALLET_AUTO_TOP_UP = 'DELETE_OWN_WALLET_AUTO_TOP_UP',

  GET_ANY_PAYMENT_METHOD = 'GET_ANY_PAYMENT_METHOD',
  GET_OWN_PAYMENT_METHOD = 'GET_OWN_PAYMENT_METHOD',
  DELETE_OWN_PAYMENT_METHOD = 'DELETE_OWN_PAYMENT_METHOD',
  DELETE_ANY_PAYMENT_METHOD = 'DELETE_ANY_PAYMENT_METHOD',

  GET_ANY_CHARGE = 'GET_ANY_CHARGE',
  LIST_ANY_CHARGE = 'LIST_ANY_CHARGE',
  GET_OWN_CHARGE = 'GET_OWN_CHARGE',
  POST_ANY_CHARGE_REFUND = 'POST_ANY_CHARGE_REFUND',
  POST_OWN_CHARGE = 'POST_OWN_CHARGE',

  GET_ANY_API_KEY = 'GET_ANY_API_KEY',
  WRITE_ANY_API_KEY = 'WRITE_ANY_API_KEY',
  DELETE_ANY_API_KEY = 'DELETE_ANY_API_KEY',

  GET_OWN_FAVORITE_LOCATION = 'GET_OWN_FAVORITE_LOCATION',
  GET_ANY_FAVORITE_LOCATION = 'GET_ANY_FAVORITE_LOCATION',
  WRITE_OWN_FAVORITE_LOCATION = 'WRITE_OWN_FAVORITE_LOCATION',
  WRITE_ANY_FAVORITE_LOCATION = 'WRITE_ANY_FAVORITE_LOCATION',
  DELETE_OWN_FAVORITE_LOCATION = 'DELETE_OWN_FAVORITE_LOCATION',
  DELETE_ANY_FAVORITE_LOCATION = 'DELETE_ANY_FAVORITE_LOCATION',
  IMPORT_ANY_FAVORITE_LOCATION = 'IMPORT_ANY_FAVORITE_LOCATION',

  GET_ANY_NOTIFICATION_SETTING = 'GET_ANY_NOTIFICATION_SETTING',
  POST_ANY_NOTIFICATION_SETTING_TEST = 'POST_ANY_NOTIFICATION_SETTING_TEST',
  WRITE_ANY_NOTIFICATION_SETTING = 'WRITE_ANY_NOTIFICATION_SETTING',
  DELETE_ANY_NOTIFICATION_SETTING = 'DELETE_ANY_NOTIFICATION_SETTING',

  GET_ANY_BULK_NOTIFICATION = 'GET_ANY_BULK_NOTIFICATION',
  WRITE_ANY_BULK_NOTIFICATION = 'WRITE_ANY_BULK_NOTIFICATION',
  POST_ANY_BULK_NOTIFICATION_SEND = 'POST_ANY_BULK_NOTIFICATION_SEND',

  GET_ANY_BULK_NOTIFICATION_ANALYTICS = 'GET_ANY_BULK_NOTIFICATION_ANALYTICS',

  GET_ANY_GROUP = 'GET_ANY_GROUP',
  LIST_ANY_GROUP = 'LIST_ANY_GROUP',
  WRITE_ANY_GROUP = 'WRITE_ANY_GROUP',
  DELETE_ANY_GROUP = 'DELETE_ANY_GROUP',

  GET_ANY_GROUP_CONDITION = 'GET_ANY_GROUP_CONDITION',
  WRITE_ANY_GROUP_CONDITION = 'WRITE_ANY_GROUP_CONDITION',
  DELETE_ANY_GROUP_CONDITION = 'DELETE_ANY_GROUP_CONDITION',

  GET_ANY_GROUP_MEMBERSHIP = 'GET_ANY_GROUP_MEMBERSHIP',
  POST_ANY_GROUP_MEMBERSHIP = 'POST_ANY_GROUP_MEMBERSHIP',
  PATCH_ANY_GROUP_MEMBERSHIP = 'PATCH_ANY_GROUP_MEMBERSHIP',
  IMPORT_ANY_GROUP_MEMBERSHIP = 'IMPORT_ANY_GROUP_MEMBERSHIP',
  EXPORT_ANY_GROUP_MEMBERSHIP = 'EXPORT_ANY_GROUP_MEMBERSHIP',
  LIST_OWN_GROUP_MEMBERSHIP = 'LIST_OWN_GROUP_MEMBERSHIP',
  GET_OWN_GROUP_MEMBERSHIP = 'GET_OWN_GROUP_MEMBERSHIP',
  POST_OWN_GROUP_MEMBERSHIP = 'POST_OWN_GROUP_MEMBERSHIP',
  PATCH_OWN_GROUP_MEMBERSHIP = 'PATCH_OWN_GROUP_MEMBERSHIP',
  DELETE_OWN_GROUP_MEMBERSHIP = 'DELETE_OWN_GROUP_MEMBERSHIP',

  GET_OWN_ORGANIZATION = 'GET_OWN_ORGANIZATION',
  GET_ANY_ORGANIZATION = 'GET_ANY_ORGANIZATION',
  LIST_ANY_ORGANIZATION = 'LIST_ANY_ORGANIZATION',
  PATCH_OWN_ORGANIZATION = 'PATCH_OWN_ORGANIZATION',
  PATCH_ANY_ORGANIZATION = 'PATCH_ANY_ORGANIZATION',
  POST_ANY_ORGANIZATION = 'POST_ANY_ORGANIZATION',
  DELETE_ANY_ORGANIZATION = 'DELETE_ANY_ORGANIZATION',

  POST_ANY_TEST_ORGANIZATION = 'POST_ANY_TEST_ORGANIZATION',
  PATCH_OWN_TEST_ORGANIZATION = 'PATCH_OWN_TEST_ORGANIZATION',
  DELETE_OWN_TEST_ORGANIZATION = 'DELETE_OWN_TEST_ORGANIZATION',
  PATCH_OWN_TEST_ORGANIZATION_CONFIGURATION = 'PATCH_OWN_TEST_ORGANIZATION_CONFIGURATION',

  POST_ANY_PAYMENT_PROVIDER = 'POST_ANY_PAYMENT_PROVIDER',
  POST_TEST_ORG_PAYMENT_PROVIDER = 'POST_TEST_ORG_PAYMENT_PROVIDER',
  PATCH_ANY_PAYMENT_PROVIDER = 'PATCH_ANY_PAYMENT_PROVIDER',

  GET_GLOBAL_STRIPE_CONFIG = 'GET_GLOBAL_STRIPE_CONFIG',

  PATCH_OWN_ORGANIZATION_NOTIFICATION_PROVIDERS = 'PATCH_OWN_ORGANIZATION_NOTIFICATION_PROVIDERS',
  PATCH_ANY_ORGANIZATION_NOTIFICATION_PROVIDERS = 'PATCH_ANY_ORGANIZATION_NOTIFICATION_PROVIDERS',
  DELETE_ORGANIZATION_RIDERS = 'DELETE_ORGANIZATION_RIDERS',

  GET_OWN_ORGANIZATION_CONFIGURATION = 'GET_OWN_ORGANIZATION_CONFIGURATION',
  GET_ANY_ORGANIZATION_CONFIGURATION = 'GET_ANY_ORGANIZATION_CONFIGURATION',
  PATCH_OWN_ORGANIZATION_CONFIGURATION = 'PATCH_OWN_ORGANIZATION_CONFIGURATION',
  PATCH_ANY_ORGANIZATION_CONFIGURATION = 'PATCH_ANY_ORGANIZATION_CONFIGURATION',

  GET_OWN_ORGANIZATION_BACKUP_SETTINGS = 'GET_OWN_ORGANIZATION_BACKUP_SETTINGS',
  GET_ANY_ORGANIZATION_BACKUP_SETTINGS = 'GET_ANY_ORGANIZATION_BACKUP_SETTINGS',
  PATCH_OWN_ORGANIZATION_BACKUP_SETTINGS = 'PATCH_OWN_ORGANIZATION_BACKUP_SETTINGS',
  PATCH_ANY_ORGANIZATION_BACKUP_SETTINGS = 'PATCH_ANY_ORGANIZATION_BACKUP_SETTINGS',

  GET_ANY_CONNECTED_ACCOUNT = 'GET_ANY_CONNECTED_ACCOUNT',
  DELETE_ANY_CONNECTED_ACCOUNT = 'DELETE_ANY_CONNECTED_ACCOUNT',
  GET_OWN_CONNECTED_ACCOUNT = 'GET_OWN_CONNECTED_ACCOUNT',
  DELETE_OWN_CONNECTED_ACCOUNT = 'DELETE_OWN_CONNECTED_ACCOUNT',

  POST_ANY_PAY_COLLECTION_CALL = 'POST_ANY_PAY_COLLECTION_CALL',
  GET_ANY_PAY_COLLECTION_CALL = 'GET_ANY_PAY_COLLECTION_CALL',
  POST_OWN_PAY_COLLECTION_CALL = 'POST_OWN_PAY_COLLECTION_CALL',
  GET_OWN_PAY_COLLECTION_CALL = 'GET_OWN_PAY_COLLECTION_CALL',

  GET_OWN_DUTY = 'GET_OWN_DUTY',
  GET_ANY_DUTY = 'GET_ANY_DUTY',
  LIST_OWN_DUTY = 'LIST_OWN_DUTY',
  LIST_ANY_DUTY = 'LIST_ANY_DUTY',
  PATCH_ANY_DUTY = 'PATCH_ANY_DUTY',
  POST_ANY_DUTY = 'POST_ANY_DUTY',
  POST_ANY_MULTIPLE_DUTIES = 'POST_ANY_MULTIPLE_DUTIES',

  DELETE_ANY_DUTY = 'DELETE_ANY_DUTY',
  DELETE_ANY_MULTIPLE_DUTIES = 'DELETE_ANY_MULTIPLE_DUTIES',

  CANCEL_OWN_DUTY = 'CANCEL_OWN_DUTY',
  CANCEL_ANY_DUTY = 'CANCEL_ANY_DUTY',
  CANCEL_ANY_MULTIPLE_DUTIES = 'CANCEL_ANY_MULTIPLE_DUTIES',

  WRITE_OWN_DUTY = 'WRITE_OWN_DUTY',

  IMPORT_ANY_DUTY = 'IMPORT_ANY_DUTY',
  EXPORT_ANY_DUTY = 'EXPORT_ANY_DUTY',

  POST_OWN_DUTY_VL = 'POST_OWN_DUTY_VL',
  POST_ANY_DUTY_VL = 'POST_ANY_DUTY_VL',
  GET_OWN_LAST_DUTY_VL = 'GET_OWN_LAST_DUTY_VL',
  GET_ANY_LAST_DUTY_VL = 'GET_ANY_LAST_DUTY_VL',
  GET_ANY_VL = 'GET_ANY_VL',

  POST_ANY_DUTY_AV_STATE = 'POST_ANY_DUTY_AV_STATE',

  CAN_OPERATE_ORGANIZATION_VEHICLE = 'CAN_OPERATE_ORGANIZATION_VEHICLE',

  GENERATE_OWN_USER_ORG_TOKENS = 'GENERATE_OWN_USER_ORG_TOKENS',
  GENERATE_ANY_USER_ORG_TOKENS = 'GENERATE_ANY_USER_ORG_TOKENS',

  JOIN_ANY_ORGANIZATION = 'JOIN_ANY_ORGANIZATION',
  JOIN_OWN_ORGANIZATION = 'JOIN_OWN_ORGANIZATION',

  LIST_ANY_ALERT = 'LIST_ANY_ALERT',
  LIST_OWN_ALERT = 'LIST_OWN_ALERT',
  PATCH_ANY_ALERT = 'PATCH_ANY_ALERT',
  PATCH_OWN_ALERT = 'PATCH_OWN_ALERT',
  POST_ANY_ALERT = 'POST_ANY_ALERT',

  LIST_ANY_ALERT_SUBSCRIPTION = 'LIST_ANY_ALERT_SUBSCRIPTION',
  LIST_OWN_ALERT_SUBSCRIPTION = 'LIST_OWN_ALERT_SUBSCRIPTION',
  POST_ANY_ALERT_SUBSCRIPTION = 'POST_ANY_ALERT_SUBSCRIPTION',
  POST_OWN_ALERT_SUBSCRIPTION = 'POST_OWN_ALERT_SUBSCRIPTION',
  DELETE_ANY_ALERT_SUBSCRIPTION = 'DELETE_ANY_ALERT_SUBSCRIPTION',
  DELETE_OWN_ALERT_SUBSCRIPTION = 'DELETE_OWN_ALERT_SUBSCRIPTION',

  RECEIVE_LATE_DUTIES_ALERT = 'RECEIVE_LATE_DUTIES_ALERT',
  RECEIVE_LATE_DUTY_START_ALERT = 'RECEIVE_LATE_DUTY_START_ALERT',
  RECEIVE_NO_SCHEDULED_DUTIES_ALERT = 'RECEIVE_NO_SCHEDULED_DUTIES_ALERT',
  RECEIVE_NEED_VEHICLE_LOCATION_UPDATE_ALERT = 'RECEIVE_NEED_VEHICLE_LOCATION_UPDATE_ALERT',
  RECEIVE_NEGATIVE_REVIEW_POSTED_ALERT = 'RECEIVE_NEGATIVE_REVIEW_POSTED_ALERT',
  RECEIVE_POSITIVE_COMMENT_REVIEW_POSTED_ALERT = 'RECEIVE_POSITIVE_COMMENT_REVIEW_POSTED_ALERT',
  RECEIVE_NO_SHOW_CANCELLATION_ALERT = 'RECEIVE_NO_SHOW_CANCELLATION_ALERT',
  RECEIVE_SYSTEM_AT_CAPACITY_ALERT = 'RECEIVE_SYSTEM_AT_CAPACITY_ALERT',
  RECEIVE_IDLE_VEHICLE_ALERT = 'RECEIVE_IDLE_VEHICLE_ALERT',
  RECEIVE_STRANDED_REQUESTS_ALERT = 'RECEIVE_STRANDED_REQUESTS_ALERT',
  RECEIVE_SIMULTANEOUS_DRIVER_LOGIN_ALERT = 'RECEIVE_SIMULTANEOUS_DRIVER_LOGIN_ALERT',
  RECEIVE_RECURRING_TRIP_FAILURE_ALERT = 'RECEIVE_RECURRING_TRIP_FAILURE_ALERT',
  RECEIVE_CASE_ASSIGNMENT_ALERT = 'RECEIVE_CASE_ASSIGNMENT_ALERT',
  RECEIVE_TRIPS_IN_RESTRICTED_AREA_ALERT = 'RECEIVE_TRIPS_IN_RESTRICTED_AREA_ALERT',
  RECEIVE_NO_DRIVERS_AVAILABLE_ALERT = 'RECEIVE_NO_DRIVERS_AVAILABLE_ALERT',
  RECEIVE_USER_MENTIONED_ALERT = 'RECEIVE_USER_MENTIONED_ALERT',

  // EAM alerts
  RECEIVE_EAM_WORK_ORDER_COMPLETED_ALERT = 'RECEIVE_EAM_WORK_ORDER_COMPLETED_ALERT',
  RECEIVE_EAM_SERVICE_REMINDER_OVERDUE_ALERT = 'RECEIVE_EAM_SERVICE_REMINDER_OVERDUE_ALERT',
  RECEIVE_EAM_SERVICE_REMINDER_DUE_SOON_ALERT = 'RECEIVE_EAM_SERVICE_REMINDER_DUE_SOON_ALERT',
  RECEIVE_EAM_LOW_PARTS_INVENTORY_ALERT = 'RECEIVE_EAM_LOW_PARTS_INVENTORY_ALERT',
  RECEIVE_EAM_ISSUE_CREATED_ALERT = 'RECEIVE_EAM_ISSUE_CREATED_ALERT',

  GET_ANY_WEBHOOK = 'GET_ANY_WEBHOOK',
  WRITE_ANY_WEBHOOK = 'WRITE_ANY_WEBHOOK',
  DELETE_ANY_WEBHOOK = 'DELETE_ANY_WEBHOOK',

  // Analytics service
  GET_ANY_ANALYTICS_DASHBOARD = 'GET_ANY_ANALYTICS_DASHBOARD',
  POST_ANY_ANALYTICS_DASHBOARD = 'POST_ANY_ANALYTICS_DASHBOARD',
  PATCH_ANY_ANALYTICS_DASHBOARD = 'PATCH_ANY_ANALYTICS_DASHBOARD',
  DELETE_ANY_ANALYTICS_DASHBOARD = 'DELETE_ANY_ANALYTICS_DASHBOARD',
  ARCHIVE_ANY_ANALYTICS_DASHBOARD = 'ARCHIVE_ANY_ANALYTICS_DASHBOARD',

  GET_ANY_ANALYTICS_REPORT = 'GET_ANY_ANALYTICS_REPORT',
  POST_ANY_ANALYTICS_REPORT = 'POST_ANY_ANALYTICS_REPORT',
  PATCH_ANY_ANALYTICS_REPORT = 'PATCH_ANY_ANALYTICS_REPORT',
  DELETE_ANY_ANALYTICS_REPORT = 'DELETE_ANY_ANALYTICS_REPORT',
  ARCHIVE_ANY_ANALYTICS_REPORT = 'ARCHIVE_ANY_ANALYTICS_REPORT',

  GET_ANY_TEMPLATE_REPORT = 'GET_ANY_TEMPLATE_REPORT',
  POST_ANY_TEMPLATE_REPORT = 'POST_ANY_TEMPLATE_REPORT',
  PATCH_ANY_TEMPLATE_REPORT = 'PATCH_ANY_TEMPLATE_REPORT',
  DELETE_ANY_TEMPLATE_REPORT = 'DELETE_ANY_TEMPLATE_REPORT',
  ARCHIVE_ANY_TEMPLATE_REPORT = 'ARCHIVE_ANY_TEMPLATE_REPORT',

  GET_ANY_TEMPLATE_DASHBOARD = 'GET_ANY_TEMPLATE_DASHBOARD',
  POST_ANY_TEMPLATE_DASHBOARD = 'POST_ANY_TEMPLATE_DASHBOARD',
  PATCH_ANY_TEMPLATE_DASHBOARD = 'PATCH_ANY_TEMPLATE_DASHBOARD',
  DELETE_ANY_TEMPLATE_DASHBOARD = 'DELETE_ANY_TEMPLATE_DASHBOARD',
  ARCHIVE_ANY_TEMPLATE_DASHBOARD = 'ARCHIVE_ANY_TEMPLATE_DASHBOARD',

  // Direct data exports
  EXPORT_ANY_PAYMENT_METHOD = 'EXPORT_ANY_PAYMENT_METHOD',
  EXPORT_ANY_PAYMENT_METHOD_TYPE = 'EXPORT_ANY_PAYMENT_METHOD_TYPE',
  EXPORT_ANY_WALLET_TRANSACTION = 'EXPORT_ANY_WALLET_TRANSACTION',
  EXPORT_ANY_RIDER = 'EXPORT_ANY_RIDER',
  EXPORT_ANY_DRIVER = 'EXPORT_ANY_DRIVER',
  EXPORT_ANY_VEHICLE = 'EXPORT_ANY_VEHICLE',
  EXPORT_ANY_PROMO_ALLOCATION = 'EXPORT_ANY_PROMO_ALLOCATION',
  EXPORT_ANY_REQUEST_RECURRENCE = 'EXPORT_ANY_REQUEST_RECURRENCE',

  // Special reports
  EXPORT_ANY_DRIVER_REPORT = 'EXPORT_ANY_DRIVER_REPORT',
  EXPORT_ANY_DRIVER_METRIC_REPORT = 'EXPORT_ANY_DRIVER_METRIC_REPORT',
  EXPORT_ANY_RIDERSHIP_REPORT = 'EXPORT_ANY_RIDERSHIP_REPORT',
  EXPORT_ANY_NTD_REPORT = 'EXPORT_ANY_NTD_REPORT',
  EXPORT_ANY_ALL_CASES_REPORT = 'EXPORT_ANY_ALL_CASES_REPORT',
  EXPORT_ANY_CASE_ACTIVITY_LOG_REPORT = 'EXPORT_ANY_CASE_ACTIVITY_LOG_REPORT',
  EXPORT_ANY_RESOLVE_ALL_CASES_REPORT = 'EXPORT_ANY_RESOLVE_ALL_CASES_REPORT',
  EXPORT_ANY_RESOLVE_CASE_ACTIVITY_LOG_REPORT = 'EXPORT_ANY_RESOLVE_CASE_ACTIVITY_LOG_REPORT',

  // Custom reports
  EXPORT_ANY_CUSTOM_WINNIPEG_FARE_REPORT = 'EXPORT_ANY_CUSTOM_WINNIPEG_FARE_REPORT',

  GET_ANY_REPORT_TEMPLATE = 'GET_ANY_REPORT_TEMPLATE',
  DELETE_ANY_REPORT_TEMPLATE = 'DELETE_ANY_REPORT_TEMPLATE',
  WRITE_ANY_REPORT_TEMPLATE = 'WRITE_ANY_REPORT_TEMPLATE',
  EXPORT_ANY_REPORT_TEMPLATE = 'EXPORT_ANY_REPORT_TEMPLATE',

  POST_ANY_ANALYZE_REPORT_JOB = 'POST_ANY_ANALYZE_REPORT_JOB',
  GET_ANY_ANALYZE_REPORT_JOB = 'GET_ANY_ANALYZE_REPORT_JOB',

  CAN_USE_ADMIN_PORTAL = 'CAN_USE_ADMIN_PORTAL',
  CAN_USE_DRIVER_APP = 'CAN_USE_DRIVER_APP',

  LIST_ANY_DEVICE = 'LIST_ANY_DEVICE',
  LIST_OWN_DEVICE = 'LIST_OWN_DEVICE',
  WRITE_OWN_DEVICE = 'WRITE_OWN_DEVICE',
  DELETE_OWN_DEVICE = 'DELETE_OWN_DEVICE',

  LIST_ANY_TIME_RULE = 'LIST_ANY_TIME_RULE',
  GET_ANY_TIME_RULE = 'GET_ANY_TIME_RULE',
  POST_ANY_TIME_RULE = 'POST_ANY_TIME_RULE',
  PATCH_ANY_TIME_RULE = 'PATCH_ANY_TIME_RULE',
  DELETE_ANY_TIME_RULE = 'DELETE_ANY_TIME_RULE',

  GET_ANY_FARE_RULE = 'GET_ANY_FARE_RULE',
  LIST_ANY_FARE_RULE = 'LIST_ANY_FARE_RULE',
  WRITE_ANY_FARE_RULE = 'WRITE_ANY_FARE_RULE',
  DELETE_ANY_FARE_RULE = 'DELETE_ANY_FARE_RULE',

  GET_ANY_REPORT = 'GET_ANY_REPORT',
  PATCH_ANY_REPORT = 'PATCH_ANY_REPORT',
  GET_ANY_REPORT_PREVIEW = 'GET_ANY_REPORT_PREVIEW',

  RECEIVE_DAILY_REPORTS = 'RECEIVE_DAILY_REPORTS',
  RECEIVE_WEEKLY_REPORTS = 'RECEIVE_WEEKLY_REPORTS',

  GET_ANY_REQUEST_HISTORY = 'GET_ANY_REQUEST_HISTORY',

  GET_ANY_REQUEST_RECURRENCE = 'GET_ANY_REQUEST_RECURRENCE',
  WRITE_ANY_REQUEST_RECURRENCE = 'WRITE_ANY_REQUEST_RECURRENCE',
  IMPORT_ANY_REQUEST_RECURRENCE = 'IMPORT_ANY_REQUEST_RECURRENCE',

  GET_OWN_REQUEST_RECURRENCE = 'GET_OWN_REQUEST_RECURRENCE',
  WRITE_OWN_REQUEST_RECURRENCE = 'WRITE_OWN_REQUEST_RECURRENCE',

  GET_ANY_MOBILE_APP = 'GET_ANY_MOBILE_APP',
  LIST_ANY_MOBILE_APP = 'LIST_ANY_MOBILE_APP',
  WRITE_ANY_MOBILE_APP = 'WRITE_ANY_MOBILE_APP',
  DELETE_ANY_MOBILE_APP = 'DELETE_ANY_MOBILE_APP',
  POST_ANY_MOBILE_APP_ORGANIZATION = 'POST_ANY_MOBILE_APP_ORGANIZATION',
  DELETE_ANY_MOBILE_APP_ORGANIZATION = 'DELETE_ANY_MOBILE_APP_ORGANIZATION',
  POST_SPARE_MOBILE_APP_ORGANIZATION = 'POST_SPARE_MOBILE_APP_ORGANIZATION',

  GET_ANY_MOBILE_APP_RELEASE = 'GET_ANY_MOBILE_APP_RELEASE',
  WRITE_ANY_MOBILE_APP_RELEASE = 'WRITE_ANY_MOBILE_APP_RELEASE',
  DELETE_ANY_MOBILE_APP_RELEASE = 'DELETE_ANY_MOBILE_APP_RELEASE',

  POST_ANY_TEST_MOBILE_APP_ORGANIZATION = 'POST_ANY_TEST_MOBILE_APP_ORGANIZATION',
  DELETE_ANY_TEST_MOBILE_APP_ORGANIZATION = 'DELETE_ANY_TEST_MOBILE_APP_ORGANIZATION',

  WRITE_ANY_CUSTOM_FIELD = 'WRITE_ANY_CUSTOM_FIELD',
  LIST_ANY_CUSTOM_FIELD = 'LIST_ANY_CUSTOM_FIELD',
  GET_NATIVE_OBJECT_EXTENSIONS = 'GET_NATIVE_OBJECT_EXTENSIONS',
  POST_ANY_CUSTOM_FIELD_GROUP = 'POST_ANY_CUSTOM_FIELD_GROUP',

  LIST_ANY_CASE_TYPE = 'LIST_ANY_CASE_TYPE',
  GET_ANY_CASE_TYPE = 'GET_ANY_CASE_TYPE',
  WRITE_ANY_CASE_TYPE = 'WRITE_ANY_CASE_TYPE',

  GET_ANY_CASE = 'GET_ANY_CASE',
  LIST_OWN_CASE = 'LIST_OWN_CASE',
  GET_OWN_CASE = 'GET_OWN_CASE',
  WRITE_ANY_CASE = 'WRITE_ANY_CASE',
  DELETE_ANY_CASE = 'DELETE_ANY_CASE',
  POST_OWN_CASE = 'POST_OWN_CASE',
  IMPORT_ANY_CASE = 'IMPORT_ANY_CASE',
  GET_ANY_CASE_SUMMARY = 'GET_ANY_CASE_SUMMARY',
  WRITE_ANY_CASE_SUMMARY = 'WRITE_ANY_CASE_SUMMARY',

  LIST_ANY_CASE_STATUS = 'LIST_ANY_CASE_STATUS',
  WRITE_ANY_CASE_STATUS = 'WRITE_ANY_CASE_STATUS',

  GET_ANY_FORM = 'GET_ANY_FORM',
  WRITE_ANY_FORM = 'WRITE_ANY_FORM',

  LIST_ANY_FORM_CONTENT = 'LIST_ANY_FORM_CONTENT',
  GET_ANY_FORM_CONTENT = 'GET_ANY_FORM_CONTENT',
  WRITE_ANY_FORM_CONTENT = 'WRITE_ANY_FORM_CONTENT',

  GET_ANY_CASE_FORM = 'GET_ANY_CASE_FORM',
  GET_OWN_CASE_FORM = 'GET_OWN_CASE_FORM',
  WRITE_ANY_CASE_FORM = 'WRITE_ANY_CASE_FORM',

  WRITE_OWN_CASE_FORM = 'WRITE_OWN_CASE_FORM',

  GET_ANY_LETTER = 'GET_ANY_LETTER',
  WRITE_ANY_LETTER = 'WRITE_ANY_LETTER',

  GET_ANY_CASE_LETTER = 'GET_ANY_CASE_LETTER',
  WRITE_ANY_CASE_LETTER = 'WRITE_ANY_CASE_LETTER',
  POST_ANY_CASE_LETTER_DOWNLOAD = 'POST_ANY_CASE_LETTER_DOWNLOAD',

  GET_ANY_WORKFLOW = 'GET_ANY_WORKFLOW',
  WRITE_ANY_WORKFLOW = 'WRITE_ANY_WORKFLOW',

  GET_ANY_WORKFLOW_RUN = 'GET_ANY_WORKFLOW_RUN',

  GET_KPI_PREDICTION = 'GET_KPI_PREDICTION',
  GET_SAMPLE_TRIPS = 'GET_SAMPLE_TRIPS',
  POST_ZONE_SUMMARY = 'POST_ZONE_SUMMARY',
  POST_ROI_CALCULATION = 'POST_ROI_CALCULATION',

  GET_ANY_PROJECT = 'GET_ANY_PROJECT',
  WRITE_ANY_PROJECT = 'WRITE_ANY_PROJECT',
  DELETE_ANY_PROJECT = 'DELETE_ANY_PROJECT',

  GET_ANY_REALIZE_SERVICE = 'GET_ANY_REALIZE_SERVICE',
  POST_ANY_REALIZE_SERVICE = 'POST_ANY_REALIZE_SERVICE',
  PATCH_ANY_REALIZE_SERVICE = 'PATCH_ANY_REALIZE_SERVICE',
  DELETE_ANY_REALIZE_SERVICE = 'DELETE_ANY_REALIZE_SERVICE',

  GET_ANY_REALIZE_ZONE = 'GET_ANY_REALIZE_ZONE',
  POST_ANY_REALIZE_ZONE = 'POST_ANY_REALIZE_ZONE',
  PATCH_ANY_REALIZE_ZONE = 'PATCH_ANY_REALIZE_ZONE',
  DELETE_ANY_REALIZE_ZONE = 'DELETE_ANY_REALIZE_ZONE',

  POST_GTFS_GRAPH = 'POST_GTFS_GRAPH',
  PATCH_GTFS_GRAPH = 'PATCH_GTFS_GRAPH',
  GET_GTFS_GRAPH = 'GET_GTFS_GRAPH',
  DELETE_GTFS_GRAPH = 'DELETE_GTFS_GRAPH',
  LIST_GTFS_GRAPH = 'LIST_GTFS_GRAPH',

  WRITE_ORGANIZATION_GRAPH = 'WRITE_ORGANIZATION_GRAPH',
  GET_ORGANIZATION_GRAPH = 'GET_ORGANIZATION_GRAPH',
  DELETE_ORGANIZATION_GRAPH = 'DELETE_ORGANIZATION_GRAPH',

  POST_GTFS_DATASET = 'POST_GTFS_DATASET',
  PATCH_GTFS_DATASET = 'PATCH_GTFS_DATASET',
  GET_GTFS_DATASET = 'GET_GTFS_DATASET',
  LIST_GTFS_DATASET = 'LIST_GTFS_DATASET',

  POST_FIXED_ROUTE_FOR_DISPLAY = 'POST_FIXED_ROUTE_FOR_DISPLAY',
  PATCH_FIXED_ROUTE_FOR_DISPLAY = 'PATCH_FIXED_ROUTE_FOR_DISPLAY',
  GET_FIXED_ROUTE_FOR_DISPLAY = 'GET_FIXED_ROUTE_FOR_DISPLAY',

  LIST_FIXED_ROUTE = 'LIST_FIXED_ROUTE',

  LIST_FIXED_ROUTE_SHAPES = 'LIST_FIXED_ROUTE_SHAPES',
  LIST_FIXED_ROUTE_DIRECTION_SHAPES = 'LIST_FIXED_ROUTE_DIRECTION_SHAPES',
  GET_FIXED_ROUTE_DIRECTION_SHAPE = 'GET_FIXED_ROUTE_DIRECTION_SHAPE',

  /**
   * As a rider, I can get the vehicle positions for the organization I'm a part of
   */
  GET_GTFS_REALTIME_VEHICLE_POSITIONS = 'GET_GTFS_REALTIME_VEHICLE_POSITIONS',

  /**
   * As a super admin, I can get the vehicle positions for any dataset
   */
  GET_ANY_GTFS_REALTIME_DATASET_VEHICLE_POSITIONS = 'GET_ANY_GTFS_REALTIME_DATASET_VEHICLE_POSITIONS',

  POST_ANY_REALIZE_FIXED_ROUTE_GTFS = 'POST_ANY_REALIZE_FIXED_ROUTE_GTFS',

  GET_ANY_REALIZE_FIXED_ROUTE = 'GET_ANY_REALIZE_FIXED_ROUTE',
  DELETE_ANY_REALIZE_FIXED_ROUTE = 'DELETE_ANY_REALIZE_FIXED_ROUTE',

  GET_ANY_REALIZE_FIXED_ROUTE_STOP = 'GET_ANY_REALIZE_FIXED_ROUTE_STOP',

  GET_ANY_REALIZE_FIXED_ROUTE_STOP_CONNECTION = 'GET_ANY_REALIZE_FIXED_ROUTE_STOP_CONNECTION',

  GET_ANY_REALIZE_FLEET = 'GET_ANY_REALIZE_FLEET',
  WRITE_ANY_REALIZE_FLEET = 'WRITE_ANY_REALIZE_FLEET',
  DELETE_ANY_REALIZE_FLEET = 'DELETE_ANY_REALIZE_FLEET',

  LIST_ANY_REALIZE_SERVICE_FLEET = 'LIST_ANY_REALIZE_SERVICE_FLEET',
  WRITE_ANY_REALIZE_SERVICE_FLEET = 'WRITE_ANY_REALIZE_SERVICE_FLEET',
  DELETE_ANY_REALIZE_SERVICE_FLEET = 'DELETE_ANY_REALIZE_SERVICE_FLEET',

  LIST_ANY_GTFS_FILES = 'LIST_ANY_GTFS_FILES',

  LIST_DIRECTION_SHAPES = 'LIST_DIRECTION_SHAPES',

  GET_ANY_REALIZE_STOP = 'GET_ANY_REALIZE_STOP',
  POST_ANY_REALIZE_STOP = 'POST_ANY_REALIZE_STOP',
  PATCH_ANY_REALIZE_STOP = 'PATCH_ANY_REALIZE_STOP',
  DELETE_ANY_REALIZE_STOP = 'DELETE_ANY_REALIZE_STOP',

  GET_ANY_DEMAND_SEGMENT = 'GET_ANY_DEMAND_SEGMENT',
  WRITE_ANY_DEMAND_SEGMENT = 'WRITE_ANY_DEMAND_SEGMENT',
  DELETE_ANY_DEMAND_SEGMENT = 'DELETE_ANY_DEMAND_SEGMENT',

  LIST_ANY_HISTORIC_TRIP_DATASET = 'LIST_ANY_HISTORIC_TRIP_DATASET',
  POST_ANY_HISTORIC_TRIP_DATASET = 'POST_ANY_HISTORIC_TRIP_DATASET',
  DELETE_ANY_HISTORIC_TRIP_DATASET = 'DELETE_ANY_HISTORIC_TRIP_DATASET',

  GET_ANY_DATASET = 'GET_ANY_DATASET',
  WRITE_ANY_DATASET = 'WRITE_ANY_DATASET',
  DELETE_ANY_DATASET = 'DELETE_ANY_DATASET',

  LIST_ANY_DATASET_POINTS = 'LIST_ANY_DATASET_POINTS',
  POST_ANY_DATASET_POINTS = 'POST_ANY_DATASET_POINTS',
  LIST_ANY_DATASET_HEATMAP_POINTS = 'LIST_ANY_DATASET_HEATMAP_POINTS',
  POST_ANY_DATASET_HEATMAP_POINTS = 'POST_ANY_DATASET_HEATMAP_POINTS',

  LIST_ANY_DATASET_POLYGON = 'LIST_ANY_DATASET_POLYGON',
  POST_ANY_DATASET_POLYGON = 'POST_ANY_DATASET_POLYGON',

  GET_ANY_DATA_RETENTION_SCHEDULE = 'GET_ANY_DATA_RETENTION_SCHEDULE',
  LIST_ANY_DATA_RETENTION_SCHEDULE = 'LIST_ANY_DATA_RETENTION_SCHEDULE',
  WRITE_ANY_DATA_RETENTION_SCHEDULE = 'WRITE_ANY_DATA_RETENTION_SCHEDULE',
  EXPORT_ANY_DATA_RETENTION_REPORT = 'EXPORT_ANY_DATA_RETENTION_REPORT',

  POST_ANY_EMAIL = 'POST_ANY_EMAIL',
  POST_ANY_SMS = 'POST_ANY_SMS',

  GET_ANY_BILLING_ACCOUNT = 'GET_ANY_BILLING_ACCOUNT',
  LIST_ANY_BILLING_ACCOUNT = 'LIST_ANY_BILLING_ACCOUNT',
  WRITE_ANY_BILLING_ACCOUNT = 'WRITE_ANY_BILLING_ACCOUNT',
  DELETE_ANY_BILLING_ACCOUNT = 'DELETE_ANY_BILLING_ACCOUNT',
  GET_OWN_BILLING_ACCOUNT_ALERT_STATUS = 'GET_OWN_BILLING_ACCOUNT_ALERT_STATUS',

  GET_ANY_BILLING_ACCOUNT_ASSIGNMENT = 'GET_ANY_BILLING_ACCOUNT_ASSIGNMENT',
  POST_ANY_BILLING_ACCOUNT_ASSIGNMENT = 'POST_ANY_BILLING_ACCOUNT_ASSIGNMENT',
  DELETE_ANY_BILLING_ACCOUNT_ASSIGNMENT = 'DELETE_ANY_BILLING_ACCOUNT_ASSIGNMENT',

  GET_SUPER_ADMIN = 'GET_SUPER_ADMIN',
  LIST_SUPER_ADMIN = 'LIST_SUPER_ADMIN',
  WRITE_SUPER_ADMIN = 'WRITE_SUPER_ADMIN',
  DELETE_SUPER_ADMIN = 'DELETE_SUPER_ADMIN',

  GET_ANY_ORGANIZATION_SUPER_ADMIN = 'GET_ANY_ORGANIZATION_SUPER_ADMIN',
  POST_ANY_ORGANIZATION_SUPER_ADMIN = 'POST_ANY_ORGANIZATION_SUPER_ADMIN',
  DELETE_ANY_ORGANIZATION_SUPER_ADMIN = 'DELETE_ANY_ORGANIZATION_SUPER_ADMIN',
  POST_OWN_ORGANIZATION_SUPER_ADMIN = 'POST_OWN_ORGANIZATION_SUPER_ADMIN',
  DELETE_OWN_ORGANIZATION_SUPER_ADMIN = 'DELETE_OWN_ORGANIZATION_SUPER_ADMIN',

  POST_ANY_EXTERNAL_DISPATCH_ESTIMATE = 'POST_ANY_EXTERNAL_DISPATCH_ESTIMATE',
  POST_ANY_EXTERNAL_DISPATCH_RIDE = 'POST_ANY_EXTERNAL_DISPATCH_RIDE',
  // TODO - look if we can change this
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  GET_ANY_EXTERNAL_DISPATCH_RIDE = 'POST_ANY_EXTERNAL_DISPATCH_ESTIMATE',
  POST_ANY_EXTERNAL_DISPATCH_RIDE_CANCEL = 'POST_ANY_EXTERNAL_DISPATCH_RIDE_CANCEL',
  POST_ANY_EXTERNAL_DISPATCH_STATUS = 'POST_ANY_EXTERNAL_DISPATCH_STATUS',

  GET_OPEN_FLEET_ESTIMATE = 'GET_OPEN_FLEET_ESTIMATE',
  POST_OPEN_FLEET_REQUEST = 'POST_OPEN_FLEET_REQUEST',
  POST_OPEN_FLEET_CANCEL_REQUEST = 'POST_OPEN_FLEET_CANCEL_REQUEST',
  GET_OPEN_FLEET_REQUEST = 'GET_OPEN_FLEET_REQUEST',

  GET_AUTOCOMPLETE_SUGGESTIONS = 'GET_AUTOCOMPLETE_SUGGESTIONS',
  GET_PLACE_DETAILS = 'GET_PLACE_DETAILS',
  GET_REVERSE_GEOCODE = 'GET_REVERSE_GEOCODE',
  GET_GEOCODE = 'GET_GEOCODE',

  GET_PUBLIC_APP = 'GET_PUBLIC_APP',
  GET_ANY_APP = 'GET_ANY_APP',
  LIST_ANY_APP = 'LIST_ANY_APP',
  WRITE_ANY_APP = 'WRITE_ANY_APP',
  PATCH_ANY_APP_CLIENT_SECRET = 'PATCH_ANY_APP_CLIENT_SECRET',
  DELETE_ANY_APP = 'DELETE_ANY_APP',

  GET_ANY_APP_WEBHOOK = 'GET_ANY_APP_WEBHOOK',
  WRITE_ANY_APP_WEBHOOK = 'WRITE_ANY_APP_WEBHOOK',
  DELETE_ANY_APP_WEBHOOK = 'DELETE_ANY_APP_WEBHOOK',
  POST_APP_WEBHOOK_SEND = 'POST_APP_WEBHOOK_SEND',

  RECEIVE_PAYMENT_METHOD_CREATED = 'RECEIVE_PAYMENT_METHOD_CREATED',
  RECEIVE_PAYMENT_METHOD_ARCHIVED = 'RECEIVE_PAYMENT_METHOD_ARCHIVED',
  RECEIVE_DUTY_MATCHING_STATUS = 'RECEIVE_DUTY_MATCHING_STATUS',

  GET_ANY_APP_INSTALLATION = 'GET_ANY_APP_INSTALLATION',
  DELETE_ANY_APP_INSTALLATION = 'DELETE_ANY_APP_INSTALLATION',

  GENERATE_WORKOS_ADMIN_PORTAL_LINK = 'GENERATE_WORKOS_ADMIN_PORTAL_LINK',
  TESTING_API_ACCESS = 'TESTING_API_ACCESS',

  /**
   * @deprecated Create dedicated permissions for your endpoints instead of using this generic permission.
   * Note: This permission was historically used for endpoints like GeographyOperations, GtfsOperations,
   * RoutingDataOperations, etc. These are used by PSM who aren't root admin users.
   */
  ROOT_ADMIN_ONLY = 'ROOT_ADMIN_ONLY',

  READ_ANY_GEOGRAPHY = 'READ_ANY_GEOGRAPHY',

  POST_OAUTH_AUTHORIZE = 'POST_OAUTH_AUTHORIZE',
  POST_OAUTH_AUTHENTICATE = 'POST_OAUTH_AUTHENTICATE',

  GET_ANY_BREAK_POLICY = 'GET_ANY_BREAK_POLICY',
  POST_ANY_BREAK_POLICY = 'POST_ANY_BREAK_POLICY',
  PATCH_ANY_BREAK_POLICY = 'PATCH_ANY_BREAK_POLICY',
  DELETE_ANY_BREAK_POLICY = 'DELETE_ANY_BREAK_POLICY',

  GET_ANY_RIDER_DRIVER_RESTRICTION = 'GET_ANY_RIDER_DRIVER_RESTRICTION',
  POST_ANY_RIDER_DRIVER_RESTRICTION = 'POST_ANY_RIDER_DRIVER_RESTRICTION',
  DELETE_ANY_RIDER_DRIVER_RESTRICTION = 'DELETE_ANY_RIDER_DRIVER_RESTRICTION',

  GET_ANY_DRIVER_BEHAVIOUR = 'GET_ANY_DRIVER_BEHAVIOUR',
  GET_OWN_DRIVER_BEHAVIOUR = 'GET_OWN_DRIVER_BEHAVIOUR',
  WRITE_ANY_DRIVER_BEHAVIOUR = 'WRITE_ANY_DRIVER_BEHAVIOUR',

  GET_ANY_RIDER_RIDER_RESTRICTION = 'GET_ANY_RIDER_RIDER_RESTRICTION',
  POST_ANY_RIDER_RIDER_RESTRICTION = 'POST_ANY_RIDER_RIDER_RESTRICTION',
  DELETE_ANY_RIDER_RIDER_RESTRICTION = 'DELETE_ANY_RIDER_RIDER_RESTRICTION',

  GET_ANY_RIDER_VEHICLE_TYPE_RESTRICTION = 'GET_ANY_RIDER_VEHICLE_TYPE_RESTRICTION',
  WRITE_ANY_RIDER_VEHICLE_TYPE_RESTRICTION = 'WRITE_ANY_RIDER_VEHICLE_TYPE_RESTRICTION',
  DELETE_ANY_RIDER_VEHICLE_TYPE_RESTRICTION = 'DELETE_ANY_RIDER_VEHICLE_TYPE_RESTRICTION',

  GET_ANY_VEHICLE_INSPECTION = 'GET_ANY_VEHICLE_INSPECTION',
  GET_OWN_VEHICLE_INSPECTION = 'GET_OWN_VEHICLE_INSPECTION',
  WRITE_ANY_VEHICLE_INSPECTION = 'WRITE_ANY_VEHICLE_INSPECTION',
  WRITE_OWN_VEHICLE_INSPECTION = 'WRITE_OWN_VEHICLE_INSPECTION',

  GET_ANY_VEHICLE_INSPECTION_TEMPLATE = 'GET_ANY_VEHICLE_INSPECTION_TEMPLATE',
  LIST_ANY_VEHICLE_INSPECTION_TEMPLATE = 'LIST_ANY_VEHICLE_INSPECTION_TEMPLATE',
  WRITE_ANY_VEHICLE_INSPECTION_TEMPLATE = 'WRITE_ANY_VEHICLE_INSPECTION_TEMPLATE',

  GET_ANY_VEHICLE_TYPE = 'GET_ANY_VEHICLE_TYPE',
  LIST_ANY_VEHICLE_TYPE = 'LIST_ANY_VEHICLE_TYPE',
  WRITE_ANY_VEHICLE_TYPE = 'WRITE_ANY_VEHICLE_TYPE',
  DELETE_ANY_VEHICLE_TYPE = 'DELETE_ANY_VEHICLE_TYPE',

  GET_ANY_CONSTRAINT_OVERRIDE_ACTION = 'GET_ANY_CONSTRAINT_OVERRIDE_ACTION',

  GET_ANY_REQUEST_CONSTRAINT_OVERRIDE = 'GET_ANY_REQUEST_CONSTRAINT_OVERRIDE',

  GET_OWN_USER_FLEET_AGREEMENT = 'GET_OWN_USER_FLEET_AGREEMENT',
  GET_ANY_USER_FLEET_AGREEMENT = 'GET_ANY_USER_FLEET_AGREEMENT',
  POST_OWN_USER_FLEET_AGREEMENT = 'POST_OWN_USER_FLEET_AGREEMENT',
  POST_ANY_USER_FLEET_AGREEMENT = 'POST_ANY_USER_FLEET_AGREEMENT',
  DELETE_OWN_USER_FLEET_AGREEMENT = 'DELETE_OWN_USER_FLEET_AGREEMENT',
  DELETE_ANY_USER_FLEET_AGREEMENT = 'DELETE_ANY_USER_FLEET_AGREEMENT',
  POST_ANY_USER_FLEET_AGREEMENT_SEND = 'POST_ANY_USER_FLEET_AGREEMENT_SEND',
  DELETE_ALL_USER_FLEET_AGREEMENT = 'DELETE_All_USER_FLEET_AGREEMENT',

  GET_OWN_DRIVER_BREAK = 'GET_OWN_DRIVER_BREAK',
  GET_ANY_DRIVER_BREAK = 'GET_ANY_DRIVER_BREAK',
  CANCEL_ANY_DRIVER_BREAK = 'CANCEL_ANY_DRIVER_BREAK',
  WRITE_ANY_DRIVER_BREAK = 'WRITE_ANY_DRIVER_BREAK',

  GET_ANY_DRIVER_BREAK_REASON = 'GET_ANY_DRIVER_BREAK_REASON',
  POST_ANY_DRIVER_BREAK_REASON = 'POST_ANY_DRIVER_BREAK_REASON',
  PATCH_ANY_DRIVER_BREAK_REASON = 'PATCH_ANY_DRIVER_BREAK_REASON',
  DELETE_ANY_DRIVER_BREAK_REASON = 'DELETE_ANY_DRIVER_BREAK_REASON',

  POST_ANTIVIRUS_SCAN = 'POST_ANTIVIRUS_SCAN',
  GET_ANTIVIRUS_VERSION = 'GET_ANTIVIRUS_VERSION',

  GET_ANY_EVENT = 'GET_ANY_EVENT',
  LIST_ANY_EVENT = 'LIST_ANY_EVENT',

  WRITE_ANY_MTI_ORGANIZATION = 'WRITE_ANY_MTI_ORGANIZATION',
  DELETE_ANY_MTI_ORGANIZATION = 'DELETE_ANY_MTI_ORGANIZATION',

  GET_ANY_DAILY_REQUEST_COUNTS = 'GET_ANY_DAILY_REQUEST_COUNTS',

  LIST_ANY_MATCHING_OUTCOMES = 'LIST_ANY_MATCHING_OUTCOMES',

  GET_ANY_OPEN_FLEET_CONFIGURATION = 'GET_ANY_OPEN_FLEET_CONFIGURATION',
  LIST_ANY_OPEN_FLEET_CONFIGURATION = 'LIST_ANY_OPEN_FLEET_CONFIGURATION',
  WRITE_ANY_OPEN_FLEET_CONFIGURATION = 'WRITE_ANY_OPEN_FLEET_CONFIGURATION',
  WRITE_ANY_OPEN_FLEET_CONFIGURATION_FORCE = 'WRITE_ANY_OPEN_FLEET_CONFIGURATION_FORCE',
  POST_ANY_OPEN_FLEET_CONFIGURATION_DUPLICATE = 'POST_ANY_OPEN_FLEET_CONFIGURATION_DUPLICATE',

  GET_ANY_OPEN_FLEET_LIMIT = 'GET_ANY_OPEN_FLEET_LIMIT',
  WRITE_ANY_OPEN_FLEET_LIMIT = 'WRITE_ANY_OPEN_FLEET_LIMIT',

  PROXY_OPEN_FLEET_WEBHOOK = 'PROXY_OPEN_FLEET_WEBHOOK',
  POST_OPEN_FLEET_WEBHOOK = 'POST_OPEN_FLEET_WEBHOOK',

  LIST_ANY_OPEN_FLEET_RECEIPT = 'LIST_ANY_OPEN_FLEET_RECEIPT',
  GET_ANY_OPEN_FLEET_RECEIPT = 'GET_ANY_OPEN_FLEET_RECEIPT',

  POST_ANY_MATCHING_SIMULATION = 'POST_ANY_MATCHING_SIMULATION',

  POST_ANY_TRIGGERED_OPTIMIZATION = 'POST_ANY_TRIGGERED_OPTIMIZATION',

  GET_ANY_PAYMENT_METHOD_TYPE = 'GET_ANY_PAYMENT_METHOD_TYPE',
  WRITE_ANY_PAYMENT_METHOD_TYPE = 'WRITE_ANY_PAYMENT_METHOD_TYPE',
  POST_TEST_ORG_PAYMENT_METHOD_TYPE = 'POST_TEST_ORG_PAYMENT_METHOD_TYPE',

  POST_METABASE_STATIC_EMBED = 'POST_METABASE_STATIC_EMBED',

  GET_ANY_SIMCITY_SIMULATION = 'GET_ANY_SIMCITY_SIMULATION',
  POST_ANY_SIMCITY_SIMULATION = 'POST_ANY_SIMCITY_SIMULATION',
  PUT_ANY_SIMCITY_SIMULATION = 'PUT_ANY_SIMCITY_SIMULATION',
  DELETE_ANY_SIMCITY_SIMULATION = 'DELETE_ANY_SIMCITY_SIMULATION',
  RESET_ANY_SIMCITY_SIMULATION = 'RESET_ANY_SIMCITY_SIMULATION',

  POST_ANY_PLEO_CREATE_LEAD_SCHEDULER = 'POST_ANY_PLEO_CREATE_LEAD_SCHEDULER',

  GET_ANY_DUTY_CONVERSATION = 'GET_ANY_DUTY_CONVERSATION',

  GET_ANY_IVR_CALL_METRICS = 'GET_ANY_IVR_CALL_METRICS',

  IMPORT_ANY_FEATURE_FLAG = 'IMPORT_ANY_FEATURE_FLAG',

  LIST_ANY_RIDER_ONBOARDING_FLOW = 'LIST_ANY_RIDER_ONBOARDING_FLOW',
  WRITE_ANY_RIDER_ONBOARDING_FLOW = 'WRITE_ANY_RIDER_ONBOARDING_FLOW',

  GET_ANY_AI_AGENT = 'GET_ANY_AI_AGENT',
  WRITE_ANY_AI_AGENT = 'WRITE_ANY_AI_AGENT',

  GET_ANY_AI_VOICE_CONVERSATION = 'GET_ANY_AI_VOICE_CONVERSATION',

  AUTH_RIDER_PHONE_PIN = 'AUTH_RIDER_PHONE_PIN',
  GET_RIDER_PHONE_PIN = 'GET_RIDER_PHONE_PIN',
  POST_RIDER_PHONE_PIN = 'POST_RIDER_PHONE_PIN',

  POST_RIDER_PHONE_ADD_SAFELIST = 'POST_RIDER_PHONE_ADD_SAFELIST',

  GET_ANY_AUTHORIZATION_GROUP = 'GET_ANY_AUTHORIZATION_GROUP',
  UPDATE_ANY_AUTHORIZATION_GROUP = 'UPDATE_ANY_AUTHORIZATION_GROUP',
  DELETE_ANY_AUTHORIZATION_GROUP = 'DELETE_ANY_AUTHORIZATION_GROUP',

  GET_ANY_AUTHORIZATION_ROLE = 'GET_ANY_AUTHORIZATION_ROLE',
  UPDATE_ANY_AUTHORIZATION_ROLE = 'UPDATE_ANY_AUTHORIZATION_ROLE',
  DELETE_ANY_AUTHORIZATION_ROLE = 'DELETE_ANY_AUTHORIZATION_ROLE',

  GET_ANY_ACCESS_GRANT = 'GET_ANY_ACCESS_GRANT',
  UPDATE_ANY_ACCESS_GRANT = 'UPDATE_ANY_ACCESS_GRANT',

  GET_ANY_AUTHORIZATION_GROUP_MEMBERSHIP = 'GET_ANY_AUTHORIZATION_GROUP_MEMBERSHIP',
  UPDATE_ANY_AUTHORIZATION_GROUP_MEMBERSHIP = 'UPDATE_ANY_AUTHORIZATION_GROUP_MEMBERSHIP',

  GET_ANY_AUTHORIZATION_PERMISSION_SET = 'GET_ANY_AUTHORIZATION_PERMISSION_SET',

  GET_SUPER_ADMIN_AUTHORIZATION_GROUP = 'GET_SUPER_ADMIN_AUTHORIZATION_GROUP',
  UPDATE_SUPER_ADMIN_USER_AUTHORIZATION_GROUP = 'UPDATE_SUPER_ADMIN_USER_AUTHORIZATION_GROUP',

  GET_SUPER_ADMIN_AUTHORIZATION_ROLE = 'GET_SUPER_ADMIN_AUTHORIZATION_ROLE',
  UPDATE_SUPER_ADMIN_USER_AUTHORIZATION_ROLE = 'UPDATE_SUPER_ADMIN_USER_AUTHORIZATION_ROLE',

  POST_ANY_DATA_MIGRATION = 'POST_ANY_DATA_MIGRATION',

  GET_ANY_CANCELLATION_REASON = 'GET_ANY_CANCELLATION_REASON',
  POST_ANY_CANCELLATION_REASON = 'POST_ANY_CANCELLATION_REASON',
  DELETE_ANY_CANCELLATION_REASON = 'DELETE_ANY_CANCELLATION_REASON',

  GET_ANY_ZONE_AREA = 'GET_ANY_ZONE_AREA',
  LIST_ANY_ZONE_AREA = 'LIST_ANY_ZONE_AREA',
  POST_ANY_ZONE_AREA = 'POST_ANY_ZONE_AREA',
  PATCH_ANY_ZONE_AREA = 'PATCH_ANY_ZONE_AREA',
  DELETE_ANY_ZONE_AREA = 'DELETE_ANY_ZONE_AREA',

  GET_ANY_ZONE_STOP = 'GET_ANY_ZONE_STOP',
  WRITE_ANY_ZONE_STOP = 'WRITE_ANY_ZONE_STOP',
  DELETE_ANY_ZONE_STOP = 'DELETE_ANY_ZONE_STOP',

  GET_OWN_NYLAS_ORGANIZATION_GRANT = 'GET_OWN_NYLAS_ORGANIZATION_GRANT',
  GET_ANY_NYLAS_ORGANIZATION_GRANT = 'GET_ANY_NYLAS_ORGANIZATION_GRANT',
  WRITE_ANY_NYLAS_ORGANIZATION_GRANT = 'WRITE_ANY_NYLAS_ORGANIZATION_GRANT',

  POST_NYLAS_AUTH = 'POST_NYLAS_AUTH',
  POST_NYLAS_CALLBACK = 'POST_NYLAS_CALLBACK',

  GET_OWN_NYLAS_ADMIN_GRANT = 'GET_OWN_NYLAS_ADMIN_GRANT',
  GET_ANY_NYLAS_ADMIN_GRANT = 'GET_ANY_NYLAS_ADMIN_GRANT',
  WRITE_OWN_NYLAS_ADMIN_GRANT = 'WRITE_OWN_NYLAS_ADMIN_GRANT',
  WRITE_ANY_NYLAS_ADMIN_GRANT = 'WRITE_ANY_NYLAS_ADMIN_GRANT',

  GET_ANY_TICKET_INSTANCE = 'GET_ANY_TICKET_INSTANCE',
  GET_OWN_TICKET_INSTANCE = 'GET_OWN_TICKET_INSTANCE',
  WRITE_ANY_TICKET_INSTANCE = 'WRITE_ANY_TICKET_INSTANCE',
  WRITE_OWN_TICKET_INSTANCE = 'WRITE_OWN_TICKET_INSTANCE',
  DELETE_ANY_TICKET_INSTANCE = 'DELETE_ANY_TICKET_INSTANCE',

  GET_ANY_APPOINTMENT_TYPE = 'GET_ANY_APPOINTMENT_TYPE',
  WRITE_ANY_APPOINTMENT_TYPE = 'WRITE_ANY_APPOINTMENT_TYPE',

  GET_ANY_APPOINTMENT_AVAILABILITY = 'GET_ANY_APPOINTMENT_AVAILABILITY',
  GET_OWN_APPOINTMENT_AVAILABILITY = 'GET_OWN_APPOINTMENT_AVAILABILITY',

  GET_ANY_APPOINTMENT = 'GET_ANY_APPOINTMENT',
  GET_OWN_APPOINTMENT = 'GET_OWN_APPOINTMENT',
  WRITE_ANY_APPOINTMENT = 'WRITE_ANY_APPOINTMENT',
  WRITE_OWN_APPOINTMENT = 'WRITE_OWN_APPOINTMENT',

  POST_ANY_COMMENT = 'POST_ANY_COMMENT',
  LIST_ANY_COMMENT = 'LIST_ANY_COMMENT',

  GET_ANY_RIDER_REPRESENTATIVE = 'GET_ANY_RIDER_REPRESENTATIVE',
  WRITE_ANY_RIDER_REPRESENTATIVE = 'WRITE_ANY_RIDER_REPRESENTATIVE',

  POST_ANY_RIDER_REPRESENTATIVE_RESPONSE = 'POST_ANY_RIDER_REPRESENTATIVE_RESPONSE',

  GET_OWN_RIDER_REPRESENTEE = 'GET_OWN_RIDER_REPRESENTEE',
  WRITE_OWN_RIDER_REPRESENTEE = 'WRITE_OWN_RIDER_REPRESENTEE',

  WRITE_OWN_RIDER_REPRESENTATIVE = 'WRITE_OWN_RIDER_REPRESENTATIVE',

  GET_NOTIFICATION_RESTRICTIONS = 'GET_NOTIFICATION_RESTRICTIONS',
  PUT_NOTIFICATION_RESTRICTIONS = 'PUT_NOTIFICATION_RESTRICTIONS',

  LIST_ROUTE_SHAPES = 'LIST_ROUTE_SHAPES',

  GET_ANY_EAM_ASSET = 'GET_ANY_EAM_ASSET',
  WRITE_ANY_EAM_ASSET = 'WRITE_ANY_EAM_ASSET',

  GET_ANY_EAM_ASSET_GROUP = 'GET_ANY_EAM_ASSET_GROUP',
  WRITE_ANY_EAM_ASSET_GROUP = 'WRITE_ANY_EAM_ASSET_GROUP',

  GET_ANY_EAM_CONTACT = 'GET_ANY_EAM_CONTACT',
  WRITE_ANY_EAM_CONTACT = 'WRITE_ANY_EAM_CONTACT',

  GET_ANY_OPEN_BOOKING_CONFIGURATION = 'GET_ANY_OPEN_BOOKING_CONFIGURATION',
  WRITE_ANY_OPEN_BOOKING_CONFIGURATION = 'WRITE_ANY_OPEN_BOOKING_CONFIGURATION',

  GET_ANY_OPEN_BOOKING_REQUEST = 'GET_ANY_OPEN_BOOKING_REQUEST',

  GET_ANY_EAM_METER_ENTRY = 'GET_ANY_EAM_METER_ENTRY',
  WRITE_ANY_EAM_METER_ENTRY = 'WRITE_ANY_EAM_METER_ENTRY',

  GET_ANY_EAM_SERVICE_TASK = 'GET_ANY_EAM_SERVICE_TASK',
  WRITE_ANY_EAM_SERVICE_TASK = 'WRITE_ANY_EAM_SERVICE_TASK',

  GET_ANY_EAM_SERVICE_PROGRAM = 'GET_ANY_EAM_SERVICE_PROGRAM',
  WRITE_ANY_EAM_SERVICE_PROGRAM = 'WRITE_ANY_EAM_SERVICE_PROGRAM',

  GET_ANY_EAM_SERVICE_SCHEDULE = 'GET_ANY_EAM_SERVICE_SCHEDULE',
  WRITE_ANY_EAM_SERVICE_SCHEDULE = 'WRITE_ANY_EAM_SERVICE_SCHEDULE',

  GET_ANY_EAM_SERVICE_SCHEDULE_TASK = 'GET_ANY_EAM_SERVICE_SCHEDULE_TASK',
  WRITE_ANY_EAM_SERVICE_SCHEDULE_TASK = 'WRITE_ANY_EAM_SERVICE_SCHEDULE_TASK',

  GET_ANY_EAM_SERVICE_REMINDER = 'GET_ANY_EAM_SERVICE_REMINDER',
  WRITE_ANY_EAM_SERVICE_REMINDER = 'WRITE_ANY_EAM_SERVICE_REMINDER',

  GET_ANY_EAM_WORK_ORDER = 'GET_ANY_EAM_WORK_ORDER',
  WRITE_ANY_EAM_WORK_ORDER = 'WRITE_ANY_EAM_WORK_ORDER',

  GET_ANY_EAM_SERVICE_ENTRY = 'GET_ANY_EAM_SERVICE_ENTRY',
  WRITE_ANY_EAM_SERVICE_ENTRY = 'WRITE_ANY_EAM_SERVICE_ENTRY',

  GET_ANY_EAM_PART = 'GET_ANY_EAM_PART',
  WRITE_ANY_EAM_PART = 'WRITE_ANY_EAM_PART',

  GET_ANY_EAM_ISSUE = 'GET_ANY_EAM_ISSUE',
  WRITE_ANY_EAM_ISSUE = 'WRITE_ANY_EAM_ISSUE',

  WRITE_ANY_EAM_PHOTO = 'WRITE_ANY_EAM_PHOTO',

  GET_ANY_EAM_PURCHASE_ORDER = 'GET_ANY_EAM_PURCHASE_ORDER',
  WRITE_ANY_EAM_PURCHASE_ORDER = 'WRITE_ANY_EAM_PURCHASE_ORDER',
  RECEIVE_ANY_EAM_PURCHASE_ORDER = 'RECEIVE_ANY_EAM_PURCHASE_ORDER',

  GET_ANY_EAM_LOCATION = 'GET_ANY_EAM_LOCATION',
  WRITE_ANY_EAM_LOCATION = 'WRITE_ANY_EAM_LOCATION',

  GET_ANY_EAM_PART_LOCATION_SETTING = 'GET_ANY_EAM_PART_LOCATION_SETTING',
  WRITE_ANY_EAM_PART_LOCATION_SETTING = 'WRITE_ANY_EAM_PART_LOCATION_SETTING',

  GET_ANY_EAM_INVENTORY = 'GET_ANY_EAM_INVENTORY',
  WRITE_ANY_EAM_INVENTORY_ADJUSTMENT = 'WRITE_ANY_EAM_INVENTORY_ADJUSTMENT',

  GET_ANY_EAM_VENDOR = 'GET_ANY_EAM_VENDOR',
  WRITE_ANY_EAM_VENDOR = 'WRITE_ANY_EAM_VENDOR',

  GET_ANY_EAM_INSPECTION_FORM = 'GET_ANY_EAM_INSPECTION_FORM',
  WRITE_ANY_EAM_INSPECTION_FORM = 'WRITE_ANY_EAM_INSPECTION_FORM',

  GET_ANY_EAM_INSPECTION = 'GET_ANY_EAM_INSPECTION',
  WRITE_ANY_EAM_INSPECTION = 'WRITE_ANY_EAM_INSPECTION',

  GET_ANY_EAM_SETTING = 'GET_ANY_EAM_SETTING',
  WRITE_ANY_EAM_SETTING = 'WRITE_ANY_EAM_SETTING',

  GET_ANY_EAM_ENERGY_TYPE = 'GET_ANY_EAM_ENERGY_TYPE',
  WRITE_ANY_EAM_ENERGY_TYPE = 'WRITE_ANY_EAM_ENERGY_TYPE',

  GET_ANY_EAM_UNIT = 'GET_ANY_EAM_UNIT',
  GET_ANY_EAM_VMRS_COMPONENTS = 'GET_ANY_EAM_VMRS_COMPONENTS',

  GET_ANY_EAM_ENERGY_ENTRY = 'GET_ANY_EAM_ENERGY_ENTRY',
  WRITE_ANY_EAM_ENERGY_ENTRY = 'WRITE_ANY_EAM_ENERGY_ENTRY',

  DELETE_ANY_ORGANIZATION_EAM_DATA = 'DELETE_ANY_ORGANIZATION_EAM_DATA',

  GET_ANY_TRIP_GROUP = 'GET_ANY_TRIP_GROUP',
  WRITE_ANY_TRIP_GROUP = 'WRITE_ANY_TRIP_GROUP',
  DELETE_ANY_TRIP_GROUP = 'DELETE_ANY_TRIP_GROUP',

  LIST_ANY_AUDIT_LOG = 'LIST_ANY_AUDIT_LOG',

  GET_ANY_AUDIT_LOG_ALERT_RULE = 'GET_ANY_AUDIT_LOG_ALERT_RULE',
  WRITE_ANY_AUDIT_LOG_ALERT_RULE = 'WRITE_ANY_AUDIT_LOG_ALERT_RULE',

  LIST_ANY_AUDIT_LOG_ALERT = 'LIST_ANY_AUDIT_LOG_ALERT',

  GET_ANY_EDI_ELIGIBILITY_CHECK = 'GET_ANY_EDI_ELIGIBILITY_CHECK',
  WRITE_ANY_EDI_ELIGIBILITY_CHECK = 'WRITE_ANY_EDI_ELIGIBILITY_CHECK',

  GET_ANY_EDI_BROKER_CONFIGURATION = 'GET_ANY_EDI_BROKER_CONFIGURATION',
  WRITE_ANY_EDI_BROKER_CONFIGURATION = 'WRITE_ANY_EDI_BROKER_CONFIGURATION',

  GET_ANY_CUSTOM_LINK = 'GET_ANY_CUSTOM_LINK',
  WRITE_ANY_CUSTOM_LINK = 'WRITE_ANY_CUSTOM_LINK',

  /**
   * Directory Sync
   */
  GET_ANY_DIRECTORY_SYNC_MAPPING = 'GET_ANY_DIRECTORY_SYNC_MAPPING',
  UPDATE_ANY_DIRECTORY_SYNC_MAPPING = 'UPDATE_ANY_DIRECTORY_SYNC_MAPPING',
  CREATE_ANY_DIRECTORY_SYNC_MAPPING = 'CREATE_ANY_DIRECTORY_SYNC_MAPPING',
  DELETE_ANY_DIRECTORY_SYNC_MAPPING = 'DELETE_ANY_DIRECTORY_SYNC_MAPPING',
  SYNC_ANY_DIRECTORY_MANUALLY = 'SYNC_ANY_DIRECTORY_MANUALLY',

  /**
   * Quick Replies
   */
  GET_ANY_QUICK_REPLY = 'GET_ANY_QUICK_REPLY',
  WRITE_ANY_QUICK_REPLY = 'WRITE_ANY_QUICK_REPLY',

  /**
   * Read access to any Twilio Connection within an organization.
   */
  GET_ANY_TWILIO_CONNECTION = 'GET_ANY_TWILIO_CONNECTION',
  /**
   * Access Twilio authentication information for any organization. Temporary and should only be granted to backend services.
   */
  GET_ANY_TWILIO_CONNECTION_SECRETS = 'GET_ANY_TWILIO_CONNECTION_SECRETS',
  /**
   * Manage any Twilio Connection within an organization.
   */
  WRITE_ANY_TWILIO_CONNECTION = 'WRITE_ANY_TWILIO_CONNECTION',

  GET_ANY_NOTIFICATION_DELIVERY_POLICY = 'GET_ANY_NOTIFICATION_DELIVERY_POLICY',
  WRITE_ANY_NOTIFICATION_DELIVERY_POLICY = 'WRITE_ANY_NOTIFICATION_DELIVERY_POLICY',

  LIST_GTFS_STOPS = 'LIST_GTFS_STOPS',
  LIST_GTFS_TRIPS = 'LIST_GTFS_TRIPS',
  LIST_GTFS_VEHICLE_RENTAL_STATIONS = 'LIST_GTFS_VEHICLE_RENTAL_STATIONS',

  ENABLE_RESTRICTED_FEATURE_FLAGS = 'ENABLE_RESTRICTED_FEATURE_FLAGS',
}
